import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { X } from "lucide-react";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

export const ExcerptReader = ({ src, title, onClose }) => {
  const box = useRef(null);
  const [width, setWidth] = useState(600);
  const [pages, setPages] = useState(0);
  useEffect(() => {
    const measure = () => box.current && setWidth(Math.min(box.current.clientWidth - 32, 820));
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-2 sm:p-6" onClick={onClose}>
      <div data-testid="excerpt-reader" onClick={(e) => e.stopPropagation()} onContextMenu={(e) => e.preventDefault()} className="bg-[#F6F2E9] rounded-2xl w-full max-w-4xl h-[92vh] flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-[#E8DCC4]">
          <p className="font-serif text-lg text-[#1F2A24] truncate">Extrait · {title}</p>
          <button onClick={onClose} data-testid="excerpt-close" className="p-2 rounded-full hover:bg-[#E8DCC4]"><X size={19} /></button>
        </div>
        <div ref={box} className="flex-1 overflow-y-auto py-4 flex flex-col items-center gap-4" data-testid="excerpt-pages">
          <Document file={src} onLoadSuccess={({ numPages }) => setPages(numPages)}
            loading={<p className="font-sans text-sm text-[#1F2A24]/60 py-10">Chargement de l'extrait…</p>}
            error={<p className="font-sans text-sm text-[#A63B36] py-10">Extrait indisponible pour le moment.</p>}>
            {Array.from({ length: pages }, (_, i) => (
              <Page key={i} pageNumber={i + 1} width={width} renderTextLayer={false} renderAnnotationLayer={false} className="shadow-md mb-4 bg-white" />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
};
